// extracted by mini-css-extract-plugin
export var button = "_dr-7";
export var buttonRow = "_dr-6";
export var fadeIn = "_dr-1";
export var gradient = "_dr-0";
export var panel = "_dr-2";
export var panelIn = "_dr-3";
export var subtitle = "_dr-5";
export var title = "_dr-4";